module.exports = __webpack_public_path__ + "static/media/site-map-back.ed536095.jpg";